function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { ApiConstants, ThunkHelper } from 'invision-core';
export var ADD_TO_BLOCKLIST = {
  BEGIN: 'ADD_TO_BLOCKLIST_BEGIN',
  SUCCESS: 'ADD_TO_BLOCKLIST_SUCCESS',
  FAILURE: 'ADD_TO_BLOCKLIST_FAILURE'
};
var ADD_TO_BLOCKLIST_EVENTS = [ADD_TO_BLOCKLIST.BEGIN, ADD_TO_BLOCKLIST.SUCCESS, ADD_TO_BLOCKLIST.FAILURE];
var addPaymentInstrumentToBlocklistPromise = function addPaymentInstrumentToBlocklistPromise(dispatch, customerId, paymentInstrumentId, reasonId, comments) {
  return ThunkHelper(dispatch, ADD_TO_BLOCKLIST_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/AddPaymentInstrumentToBlocklist',
    data: {
      PaymentInstrumentId: paymentInstrumentId,
      Reason: reasonId,
      Comments: comments
    },
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  });
};
export var addPaymentInstrumentToBlocklist = function addPaymentInstrumentToBlocklist(customerId, paymentInstrumentId, reasonId, comments) {
  return function (dispatch) {
    return addPaymentInstrumentToBlocklistPromise(dispatch, customerId, paymentInstrumentId, reasonId, comments);
  };
};
export var ADD_TO_ALLOWLIST = {
  BEGIN: 'ADD_TO_ALLOWLIST_BEGIN',
  SUCCESS: 'ADD_TO_ALLOWLIST_SUCCESS',
  FAILURE: 'ADD_TO_ALLOWLIST_FAILURE'
};
var ADD_TO_ALLOWLIST_EVENTS = [ADD_TO_ALLOWLIST.BEGIN, ADD_TO_ALLOWLIST.SUCCESS, ADD_TO_ALLOWLIST.FAILURE];
var addPaymentInstrumentToAllowlistPromise = function addPaymentInstrumentToAllowlistPromise(dispatch, customerId, paymentInstrumentId, reasonId, comments) {
  return ThunkHelper(dispatch, ADD_TO_ALLOWLIST_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/AddPaymentInstrumentToAllowlist',
    data: {
      PaymentInstrumentId: paymentInstrumentId,
      Reason: reasonId,
      Comments: comments
    },
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  });
};
export var addPaymentInstrumentToAllowlist = function addPaymentInstrumentToAllowlist(customerId, paymentInstrumentId, reasonId, comments) {
  return function (dispatch) {
    return addPaymentInstrumentToAllowlistPromise(dispatch, customerId, paymentInstrumentId, reasonId, comments);
  };
};
export var REMOVE_FROM_BLOCKLIST = {
  BEGIN: 'REMOVE_FROM_BLOCKLIST_BEGIN',
  SUCCESS: 'REMOVE_FROM_BLOCKLIST_SUCCESS',
  FAILURE: 'REMOVE_FROM_BLOCKLIST_FAILURE'
};
var REMOVE_FROM_BLOCKLIST_EVENTS = [REMOVE_FROM_BLOCKLIST.BEGIN, REMOVE_FROM_BLOCKLIST.SUCCESS, REMOVE_FROM_BLOCKLIST.FAILURE];
var removePaymentInstrumentFromBlocklistPromise = function removePaymentInstrumentFromBlocklistPromise(dispatch, customerId, paymentInstrumentId, reasonId, comments) {
  return ThunkHelper(dispatch, REMOVE_FROM_BLOCKLIST_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/RemovePaymentInstrumentFromBlocklist',
    data: {
      PaymentInstrumentId: paymentInstrumentId,
      Reason: reasonId,
      Comments: comments
    },
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  });
};
export var removePaymentInstrumentFromBlocklist = function removePaymentInstrumentFromBlocklist(customerId, paymentInstrumentId, reasonId, comments) {
  return function (dispatch) {
    return removePaymentInstrumentFromBlocklistPromise(dispatch, customerId, paymentInstrumentId, reasonId, comments);
  };
};
export var REMOVE_FROM_ALLOWLIST = {
  BEGIN: 'REMOVE_FROM_ALLOWLIST_BEGIN',
  SUCCESS: 'REMOVE_FROM_ALLOWLIST_SUCCESS',
  FAILURE: 'REMOVE_FROM_ALLOWLIST_FAILURE'
};
var REMOVE_FROM_ALLOWLIST_EVENTS = [REMOVE_FROM_ALLOWLIST.BEGIN, REMOVE_FROM_ALLOWLIST.SUCCESS, REMOVE_FROM_ALLOWLIST.FAILURE];
var removePaymentInstrumentFromAllowlistPromise = function removePaymentInstrumentFromAllowlistPromise(dispatch, customerId, paymentInstrumentId, reasonId, comments) {
  return ThunkHelper(dispatch, REMOVE_FROM_ALLOWLIST_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/RemovePaymentInstrumentFromAllowlist',
    data: {
      PaymentInstrumentId: paymentInstrumentId,
      Reason: reasonId,
      Comments: comments
    },
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  });
};
export var removePaymentInstrumentFromAllowlist = function removePaymentInstrumentFromAllowlist(customerId, paymentInstrumentId, reasonId, comments) {
  return function (dispatch) {
    return removePaymentInstrumentFromAllowlistPromise(dispatch, customerId, paymentInstrumentId, reasonId, comments);
  };
};
export var SET_SELECTED_REASON_ID = 'SET_SELECTED_REASON_ID';
export var setSelectedReasonId = function setSelectedReasonId(reasonId) {
  return {
    type: SET_SELECTED_REASON_ID,
    payload: reasonId
  };
};